import React, { Fragment } from "react"

import {
  AccordionComponent as Accordion,
  Summary,
  Details,
  Text,
} from "components/ui/Accordion"

const Content = () => {
  return (
    <Fragment>
      <Accordion>
        <Summary>Introduction</Summary>
        <Details>
          <Text>
            This privacy notice (hereinafter <strong>Privacy Notice</strong>)
            has been prepared by <strong>Fresh Finance OÜ</strong> (hereinafter{" "}
            <strong>Fresh Finance, we, us</strong>), a company registered in the
            Republic of Estonia, registry code 12243370, address at Tartu mnt
            83, 10115 Tallinn, Estonia. Fresh Finance is a licensed credit
            provider, operating under license number 4.1-1/45.
          </Text>
          <Text>
            This Privacy Notice applies to all individuals from whom or about
            whom Fresh Finance collects or receives personal data in the course
            of providing its services or other business activities (hereinafter{" "}
            <strong>data subjects</strong> or <strong>you</strong>).
          </Text>
          <Text>
            Fresh Finance also engages in credit management activities on behalf
            of AS PlusPlus Capital (registry code 11919806, address Tartu mnt
            83, 10115 Tallinn, hereinafter <strong>PlusPlus Capital</strong>) or
            PlusPlus Baltic OU8 (registry code 12273105, address Tartu mnt 83,
            10115 Tallinn, hereinafter <strong>PlusPlus Baltic</strong>,
            PlusPlus Capital and PlusPlus Baltic collectively referred to as{" "}
            <strong>Creditors</strong>.)
          </Text>
          <Text>
            This Privacy Notice applies to all personal data processed by Fresh
            Finance and describes how we collect, use, and process your personal
            data.
          </Text>
          <Text>
            Fresh Finance processes your personal data in accordance with
            applicable data protection laws, including the General Data
            Protection Regulation (Regulation (EU) 2016/679) (hereinafter the{" "}
            <strong>GDPR</strong>) and other relevant data protection laws.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Data controller</Summary>
        <Details>
          <Text>
            Fresh Finance is the data controller responsible for processing your
            personal data in accordance with this Privacy Notice and applicable
            data protection laws.
          </Text>
          <Text>Data Protection Officer Contact Information:</Text>
          <Text>
            <ul>
              <li>
                <strong>Name:</strong> Krõõt Kilvet
              </li>
              <li>
                <strong>Address:</strong> Tartu mnt 83, 10115 Tallinn, Estonia
              </li>
              <li>
                <strong>Email:</strong>{" "}
                <a
                  href="mailto:kroot.kilvet@punkfinance.ee"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  kroot.kilvet@punkfinance.ee
                </a>
              </li>
            </ul>
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Categories of personal data processed</Summary>
        <Details>
          <Text>
            We may collect, store, use, transfer, and otherwise process the
            following personal data about you:
          </Text>
          <Text>
            <ul>
              <li>
                <strong>identifying information:</strong> first name, last name,
                personal identification code, date and place of birth,
                nationality, details and copy of an identity document, photo,
                etc.
              </li>
              <li>
                <strong>contact information:</strong> address, phone number,
                email address, etc.
              </li>
              <li>
                <strong>employment details:</strong> current employer,
                employment history, job position, etc.
              </li>
              <li>
                <strong>financial data:</strong> income, assets, liabilities,
                guarantees, pledges, etc.
              </li>
              <li>
                <strong>contract and transaction data:</strong> details of
                claims or contracts acquired by the Creditors, bank account
                numbers, income details, asset details, payment history, etc.
              </li>
              <li>
                <strong>business-related information:</strong> details of
                related persons from business registers.
              </li>
              <li>
                <strong>IP address and analytical data.</strong>
              </li>
              <li>
                <strong>
                  criminal record and politically exposed person data, etc.
                </strong>
              </li>
            </ul>
            If you refuse to provide certain personal data, Fresh Finance may be
            unable to fulfill contractual obligations or continue the
            contractual relationship.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Sources of personal data collection</Summary>
        <Details>
          <Text>We collect your personal data from the following sources:</Text>
          <Text>
            <ul>
              <li>
                <strong>Directly from you:</strong> e.g., via self-service
                forms, telephone or email communication, and legal proceedings.
              </li>
              <li>
                <strong>From Fresh Finance’s group companies.</strong>
              </li>
              <li>
                <strong>From third parties:</strong> including publicly
                available sources such as data on claims or contracts held by
                Creditors, related persons (e.g., guarantors, co-borrowers,
                collateral providers), public authorities (courts, bailiffs,
                bankruptcy trustees, etc.), public electronic databases (debt
                registers, land registries, commercial registers, etc.) and
                search engines.
              </li>
            </ul>
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Purposes and legal basis for data processing</Summary>
        <Details>
          <Text>
            We process your personal data for speciVic purposes in accordance
            with the GDPR and applicable laws. Legal bases for processing
            include:
            <ul>
              <li>
                Article 6(1)(b) GDPR – performance of a contract or steps taken
                prior to entering into a contract:
                <ul>
                  <li>
                    entering your data into relevant registers for background
                    checks and fulVilling Creditor claims;
                  </li>
                  <li>recording your data in our information systems;</li>
                  <li>
                    handling and collecting claims against you or another
                    involved person.
                  </li>
                </ul>
              </li>
              <li>
                Article 6(1)(c) GDPR – compliance with legal or regulatory
                obligations:
                <ul>
                  <li>accounting and auditing obligations;</li>
                  <li>
                    compliance with laws on anti-money laundering, consumer
                    credit, taxation, Vinancial auditing, and sanctions.
                  </li>
                </ul>
              </li>
              <li>
                Article 6(1)(f) GDPR – legitimate interests:
                <ul>
                  <li>internal business reporting and communication;</li>
                  <li>
                    advising you on fulVilling your obligations to Creditors;
                  </li>
                  <li>
                    Development of IT systems, websites, and self-service
                    systems.
                  </li>
                  <li>Offering new services or products.</li>
                </ul>
              </li>
              <li>
                Article 6(1)(a) GDPR – Consent:
                <ul>
                  <li>When processing is based on your explicit consent.</li>
                </ul>
              </li>
            </ul>
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Sharing personal data</Summary>
        <Details>
          <Text>
            To achieve the processing purposes described in this Privacy Notice,
            we may share your personal data with:
          </Text>
          <Text>
            <ul>
              <li>Fresh Finance’s group companies.</li>
              <li>
                Authorities, such as the Tax and Customs Board, the Financial
                Supervision and Resolution Authority, and the Financial
                Intelligence Unit.
              </li>
              <li>Cloud storage service providers.</li>
              <li>Customer support service providers.</li>
              <li>Fraud and financial crime prevention service providers.</li>
              <li>
                Other third parties, including courier services, debt collection
                agencies, auditors, legal service providers, courts, bailiffs,
                and bankruptcy trustees.
              </li>
            </ul>
          </Text>
          <Text>
            We require all third-party service providers to ensure the security
            of your data and to process it only in accordance with our
            instructions, the GDPR, and applicable laws.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Transfer of personal data outside the eea</Summary>
        <Details>
          <Text>
            In some cases, we may transfer your personal data to recipients
            outside the European Economic Area (EEA). For such transfers, we
            apply adequate safeguards under the GDPR, such as EU Standard
            Contractual Clauses or approved certification mechanisms. If
            personal data is transferred to the United States, the recipient may
            be part of the EU-U.S. Data Privacy Framework (Privacy Shield).
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Data retention and security</Summary>
        <Details>
          <Text>
            We will process your personal data during the performance of a
            contract or other arrangement and will retain your personal data for
            as long as necessary to fulfill the purposes for which it was
            collected, including to comply with any legal or accounting
            requirements applicable to us.
          </Text>
          <Text>
            We will retain non-personal and statistical information about the
            usage of our websites for 3 years.
          </Text>
          <Text>
            The personal data related to contracts and/or transactions form part
            of our accounting and economic activities records and will be
            retained for at least 10 years from the end of the recording year.
            The retention period may be longer if processing of your personal
            data is necessary to comply with other applicable laws or processing
            is required to meet other requirements related to our core economic
            activities (for example, to exercise or defend a legal claim). Once
            the retention period has passed, we will either delete your personal
            data or anonymize your personal data.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Your rights</Summary>
        <Details>
          <Text>
            In accordance with the GDPR and applicable law, you have the
            following rights in relation to your personal data:
          </Text>
          <Text>
            <ul>
              <li>to request access to your personal data;</li>
              <li>
                to request rectiVication of your personal data. Please note that
                we may need to verify the correctness of the data you provide to
                us;
              </li>
              <li>
                to request erasure of your personal data. Please note that we
                are not always required to comply with your request due to legal
                grounds (for example, if the personal data is necessary for the
                establishment, exercise or defence of legal claims), about
                which, however, will inform you about in response to your
                request;
              </li>
              <li>
                right to lodge a complaint- if you think your privacy rights
                have been breached, you have the right to lodge a complaint with
                an authority of the country of your habitual residence. Contact
                information for these authorities can be accessed here:{" "}
                <a
                  href="http://ec.europa.eu/newsroom/article29/item-detail.cfm?item_id=612080"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  http://ec.europa.eu/newsroom/article29/item-detail.cfm?item_id=612080
                </a>
              </li>
            </ul>
          </Text>
          <Text>
            Under certain circumstances, you may also have a right to data
            portability, to request a restriction on processing of your personal
            data or to object to processing of your personal data.
          </Text>
          <Text>
            You may exercise your rights in line with the requirements of the
            GDPR and other applicable laws.
          </Text>
          <Text>
            To exercise your rights, please contact us via email at{" "}
            <a
              href="mailto:support@freshfinance.ee"
              target="_blank"
              rel="noopener noreferrer"
            >
              support@freshfinance.ee
            </a>
            . We may need to request certain information or documents from you
            to help us confirm your identity upon communicating with you
            regarding your privacy rights. This is necessary to ensure that
            personal data is not disclosed to any person who is not you or
            entitled to receive your personal data.
          </Text>
        </Details>
      </Accordion>

      <Accordion>
        <Summary>Changes to this notice</Summary>
        <Details>
          <Text>
            We may update this privacy notice from time to time and will inform
            you of any significant changes. For further information, please
            contact us at{" "}
            <a
              href="mailto:support@freshfinance.ee"
              target="_blank"
              rel="noopener noreferrer"
            >
              support@freshfinance.ee
            </a>
          </Text>
        </Details>
      </Accordion>
    </Fragment>
  )
}

export default Content
